interface IBackgroundSaveChanges {
  onCancel: () => void;
  saveChanges: any;
}

export default function BackgroundSaveChanges({ saveChanges, onCancel }: IBackgroundSaveChanges) {
  return (
    <div className="transparent font-lato">
      <div className="relative border-x border-t bg-gray-bg-dark border-gray-300  bg-white pb-7 pt-9 px-7 w-screen md:w-[520px] md:min-h-[100px] rounded-t-lg">
        <div className="flex mb-5">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Save changes?</span>
        </div>
        <p>
          If the video is not available yet, the mix with the new background image will be created once the files are
          available.
        </p>
        <p className="mt-2">
          If the video need to be reprocessed, you won’t be able to make further edits during processing, the video
          won’t be viewable and all video edits will be lost.
        </p>
      </div>
      <div className="flex text-[13px] pb-6 px-4 bg-white rounded-b-lg border-x">
        <button
          className="py-3 px-8 text-black border border-tabBorder ml-auto rounded-[10px] hover:bg-gray-100"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className="bg-red-main py-3 px-8 text-white ml-2 rounded-[10px]"
          onClick={async () => {
            await saveChanges();
          }}
        >
          Save changes
        </button>
      </div>
    </div>
  );
}
